import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { giveawayLandingActiveItemsSelector, giveawayLandingProductQuantitySelector, selectedGiveawayProductChoiceSelector, selectedGiveawayProductsWithAvailableSelector, isCurrentGiveawayReserveSelector, selectedGiveawayColorWithFallbackSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { setGiveawayLandingActiveItem, removeGiveawayLandingActiveItem } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { GiveawayProductsListComponent } from './giveaway-products-list';
const selector = createStructuredSelector({
  productChoice: selectedGiveawayProductChoiceSelector,
  productQuantity: giveawayLandingProductQuantitySelector,
  products: selectedGiveawayProductsWithAvailableSelector,
  giveawayColor: selectedGiveawayColorWithFallbackSelector,
  activeProducts: giveawayLandingActiveItemsSelector,
  isReserve: isCurrentGiveawayReserveSelector
});
const mapDispatchToProps = dispatch => bindActionCreators({
  setGiveawayLandingActiveItem,
  removeGiveawayLandingActiveItem
}, dispatch);
export const GiveawayProductsList = connect(selector, mapDispatchToProps)(GiveawayProductsListComponent);